import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW2300Model } from './kymw2300.model';
import { GetPageInfoService } from './api-services/get-page-info.service';
import { CheckProgressHistoryService } from './api-services/check-progress-history.service';
import { ExecutePrintCompanyDataService } from './api-services/execute-print-company-data.service';
import { ExecutePrintCompanyDataThumbnailService } from './api-services/execute-print-company-data-thumbnail.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { CatalogLockService } from '../../../commons/kymw00/api-services/catalog-lock.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { FlexGrid } from '@grapecity/wijmo.grid';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { VMediumTypeComboBoxComponent } from '../../../commons/kymw02/combo-box/vmedium-type-combo-box/vmedium-type-combo-box.component';
import { CodeComboBoxComponent } from '../../../commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { CoopCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/coop-code-combo-box/coop-code-combo-box.component';
import { RadioLabelComponent } from '../../../commons/kymw02/radio-label/radio-label.component';
import { CheckboxLabelComponent } from '../../../commons/kymw02/checkbox-label/checkbox-label.component';
import { CanDeactivateType } from 'src/app/shared/utils/leave-confirm.guard';

/**
 * 印刷会社用データ出力画面を管理するクラス
 *
 * @export KYMW2300Component
 * @class KYMW2300Component
 */
@Component({
  selector: 'app-kymw2300',
  templateUrl: 'kymw2300.component.html',
  styleUrls: ['kymw2300.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW2300Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  // ロック情報
  private lockedOrderCode = '';
  private lockedMediumType = '';

  kymw2300Model: KYMW2300Model = new KYMW2300Model();
  @ViewChild('dgv_PageList', { static: true }) dgv_PageList: FlexGrid;
  @ViewChild('cmb_TargetProgress', { static: true }) cmb_TargetProgress: CodeComboBoxComponent;
  @ViewChild('cmb_CompareProgress', { static: true }) cmb_CompareProgress: CodeComboBoxComponent;
  @ViewChild('rdb_All', { static: true }) rdb_All: RadioLabelComponent;
  @ViewChild('rdb_Diff', { static: true }) rdb_Diff: RadioLabelComponent;
  @ViewChild('txi_OrderCode', { static: true }) txi_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('cmb_Medium', { static: true }) cmb_Medium: VMediumTypeComboBoxComponent;
  @ViewChild('btn_AllCheck', { static: true }) btn_AllCheck: ElementRef;
  @ViewChild('btn_AllUnCheck', { static: true }) btn_AllUnCheck: ElementRef;
  @ViewChild('btn_Output', { static: true }) btn_Output: ElementRef;
  @ViewChild('btn_Output_Thumbnail', { static: true }) btn_Output_Thumbnail: ElementRef;
  @ViewChild('cmb_Coop', { static: true }) cmb_Coop: CoopCodeComboBoxComponent;
  @ViewChild('ckb_Manuscripts', { static: true }) ckb_Manuscripts: CheckboxLabelComponent;
  @ViewChild('ckb_BuyerDifferenceList', { static: true }) ckb_BuyerDifferenceList: CheckboxLabelComponent;
  @ViewChild('ckb_EditDifferenceList', { static: true }) ckb_EditDifferenceList: CheckboxLabelComponent;
  data = Object;

  /**
   *Creates an instance of KYMW2300Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetPageInfoService} getPageInfoService
   * @param {CheckProgressHistoryService} checkProgressHistoryService
   * @param {ExecutePrintCompanyDataService} executePrintCompanyDataService
   * @param {ExecutePrintCompanyDataThumbnailService} executePrintCompanyDataThumbnailService
   * @param {CatalogLockService} catalogLockServiceSub
   * @param {PageLockService} pageLockServiceSub
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW2300Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    private getPageInfoService: GetPageInfoService,
    private checkProgressHistoryService: CheckProgressHistoryService,
    private executePrintCompanyDataService: ExecutePrintCompanyDataService,
    private executePrintCompanyDataThumbnailService: ExecutePrintCompanyDataThumbnailService,
    public fileDownloadConfirmService: FileDownloadConfirmService,
    private catalogLockServiceSub: CatalogLockService,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW2300Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW2300';
    this.kymw2300Model.kymw2300Component = this;
    this.catalogLockService = this.catalogLockServiceSub;

    this.dgv_PageList.itemsSourceChanged.addHandler(() => {
      this.dgv_PageList.select(-1, -1);

      // 検索結果一覧のチェック
      if (PlessViewUtilsSub.isEmptyArray(this.kymw2300Model.pageList)) {        // 該当データなしの場合
        this.plessEnabled(this.btn_AllCheck, false);
        this.plessEnabled(this.btn_AllUnCheck, false);
      } else {                                                                  // 該当データありの場合
        this.plessEnabled(this.btn_AllCheck, true);
        this.plessEnabled(this.btn_AllUnCheck, true);
      }
    });

    this.dgv_PageList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dgv_PageList.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_page_list_${ht.row}`).click();
      }
    });

    // フォーカス
    this.txi_OrderCode.setFocus();

    setTimeout(() => {
      this.plessEnabledSetting();
    });
  }

  /**
   * ngOnInit内で設定するplessEnabledの処理を記述するメソッド
   *
   * @memberof KYMW2300Component
   */
  public plessEnabledSetting() {
    this.plessEnabled(this.btn_AllCheck, false);
    this.plessEnabled(this.btn_AllUnCheck, false);
    this.plessEnabled(this.rdb_Diff, false);
    if (this.getFuncPermission() === '2') {
      this.plessEnabled(this.btn_Output, true);
      this.plessEnabled(this.btn_Output_Thumbnail, true);
    } else {
      this.plessEnabled(this.btn_Output, false);
      this.plessEnabled(this.btn_Output_Thumbnail, false);
    }
  }

  /**
   * 受注コード入力イベント
   *
   * @memberof KYMW2300Component
   */
  public bindOrderCodeEvent(): void {
    this.cmb_TargetProgress.setCodeValue('');
    this.cmb_CompareProgress.setCodeValue('');
    this.kymw2300Model.pageList = new Array<any>();
    this.kymw2300Model.mediumType = '';
    this.kymw2300Model.outputType = '0';                                        // 出力方法タイプ(0：全て)
    this.plessEnabled(this.rdb_Diff, false);
    this.kymw2300Model.selectedTargetProgressNum = '';
    this.kymw2300Model.selectedCompareProgressNum = '';

    this.exclusiveAccessControl();
  }

  /**
   * 媒体区分変更イベント
   *
   * @memberof KYMW2300Component
   */
  public bindMediumTypetEvent(): void {
    this.LockUtilForCatalog('RELEASE', this.lockedOrderCode, this.lockedMediumType, null, null, null, null, false);

    this.cmb_TargetProgress.setCodeValue('');
    this.cmb_CompareProgress.setCodeValue('');
    this.kymw2300Model.pageList = new Array<any>();
    this.kymw2300Model.outputType = '0';                                        // 出力方法タイプ(0：全て)
    this.plessEnabled(this.rdb_Diff, false);
    this.kymw2300Model.selectedTargetProgressNum = '';
    this.kymw2300Model.selectedCompareProgressNum = '';

    this.exclusiveAccessControl();
  }

  /**
   * 排他制御処理
   */
  private exclusiveAccessControl(): void {
    this.exclusiveAccessControlSuccess();
  }

  /**
   * 排他ロック成功
   */
  private exclusiveAccessControlSuccess(): void {
    this.lockedOrderCode = this.txi_OrderCode.selectedOrderCode;
    this.lockedMediumType = this.cmb_Medium.selectedMediumType;
    if (this.getFuncPermission() === '2') {
      this.plessEnabled(this.btn_Output, true);
      this.plessEnabled(this.btn_Output_Thumbnail, true);
    } else {
      this.plessEnabled(this.btn_Output, false);
      this.plessEnabled(this.btn_Output_Thumbnail, false);
    }
  }

  /**
   * 会員生協変更イベント
   *
   * @memberof KYMW2300Component
   */
  public bindCoopCodeEvent(): void {
    this.dispatcherGetPageInfoEvent();
  }

  public dispatcherGetPageInfoEvent(): void {
    // ページ取得イベントを発行する
    if (this.isSelectedAllInfo()) {
      // API呼び出し
      const vo = this.kymw2300Model.getGetPageInfoVO();
      this.getPageInfoService.execute(this.kymw2300Model, vo, (data: any) => {
        this.kymw2300Model.updatePageList(data);
      });
    } else {
      this.kymw2300Model.pageList = new Array<any>();
    }
  }

  /**
   * 受注コード、媒体、会員生協(全生協)、出力対象(最新情報)が選択されたのか
   */
  private isSelectedAllInfo(): boolean {
    if (!PlessViewUtilsSub.isEmpty(this.txi_OrderCode.selectedOrderCode)
      && !PlessViewUtilsSub.isEmpty(this.cmb_Medium.selectedMediumType)
      && !PlessViewUtilsSub.isEmpty(this.cmb_Coop.selectedCoopCode)
      && this.cmb_Coop.selectedCoopCode !== '*'
      && !PlessViewUtilsSub.isEmpty(this.cmb_TargetProgress.selectedCodeValue)) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * 終了ボタンクリックイベント
   *
   * @memberof KYMW2300Component
   */
  canDeactivate(): CanDeactivateType {
    this.LockUtilForCatalog('RELEASE', this.lockedOrderCode, this.lockedMediumType, null, null, null, null, false);
    return true;
  }

  /**
   * 出力ボタン押下イベント
   */
  public eventBtnOutput_CLICKHandler(): void {
    // 出力確認メッセージを表示する。
    this.dialogService.openAlertGetMessage('Q0109', null,
    (closeDetail) => {
      this.eventBtnOutput_CLICKHandlerClose(closeDetail);
    });
  }

  /**
   * 出力ボタン押下イベントクローズ
   */
  private eventBtnOutput_CLICKHandlerClose(closeDetail: number): void {
    if (closeDetail === PlessAlert.Yes) {
      // 「受注コード」「媒体」「会員生協」「出力対象」の何れかが未入力（未選択）の場合、
      if (PlessViewUtilsSub.isEmpty(this.kymw2300Model.orderCode)) {
        this.dialogService.openAlertGetMessage('W0001', ['受注コード']);
        return;
      }
      if (!this.txi_OrderCode.isValidOrderCode()) {
        this.dialogService.openAlertGetMessage('W0024', ['受注コード']);
        return;
      }
      if (PlessViewUtilsSub.isEmpty(this.cmb_Medium.selectedMediumType)) {
        this.dialogService.openAlertGetMessage('W0001', ['媒体']);
        return;
      }
      if (PlessViewUtilsSub.isEmpty(this.cmb_Coop.selectedCoopCode)) {
        this.dialogService.openAlertGetMessage('W0001', ['会員生協']);
        return;
      }
      if (PlessViewUtilsSub.isEmpty(this.cmb_TargetProgress.selectedCodeValue)) {
        this.dialogService.openAlertGetMessage('W0001', ['出力対象']);
        return;
      }
      // 「会員生協」が"全生協"以外の場合は選択ページ件数チェックを行う。
      if (this.cmb_Coop.selectedCoopCode !== '*' && PlessViewUtilsSub.isEmpty(this.kymw2300Model.getSelectedPageIdList())) {
        this.dialogService.openAlertGetMessage('E0107', ['会員生協に「全生協」以外', 'ページ']);
        return;
      }
      // 出力指定の選択必須チェックを行う。
      if (!this.ckb_Manuscripts.selected &&
        !this.ckb_BuyerDifferenceList.selected &&
        !this.ckb_EditDifferenceList.selected) {
        this.dialogService.openAlertGetMessage('E0209', ['出力指定']);
        return;
      }
      // API呼び出し
      const vo = this.kymw2300Model.getExecutePrintCompanyDataVO();
      this.executePrintCompanyDataService.execute(this.kymw2300Model, vo, (data: any) => {
        this.data = data;
      });
    }
  }

  /**
   * 出力(サムネイル)ボタン押下イベント
   */
  public eventBtnOutputThumbnail_CLICKHandler(): void {
    // 出力確認メッセージを表示する。
    this.dialogService.openAlertGetMessage('Q0159', null,
    (closeDetail) => {
      this.eventBtnOutputThumbnail_CLICKHandlerClose(closeDetail);
    });
  }

  /**
   * 出力(サムネイル)ボタン押下イベントクローズ
   */
  private eventBtnOutputThumbnail_CLICKHandlerClose(closeDetail: number): void {
    if (closeDetail === PlessAlert.Yes) {
      // 「受注コード」「媒体」「会員生協」「出力対象」の何れかが未入力（未選択）の場合、
      if (PlessViewUtilsSub.isEmpty(this.kymw2300Model.orderCode)) {
        this.dialogService.openAlertGetMessage('W0001', ['受注コード']);
        return;
      }
      if (!this.txi_OrderCode.isValidOrderCode()) {
        this.dialogService.openAlertGetMessage('W0024', ['受注コード']);
        return;
      }
      if (PlessViewUtilsSub.isEmpty(this.cmb_Medium.selectedMediumType)) {
        this.dialogService.openAlertGetMessage('W0001', ['媒体']);
        return;
      }
      if (PlessViewUtilsSub.isEmpty(this.cmb_Coop.selectedCoopCode)) {
        this.dialogService.openAlertGetMessage('W0001', ['会員生協']);
        return;
      }
      if (PlessViewUtilsSub.isEmpty(this.cmb_TargetProgress.selectedCodeValue)) {
         this.dialogService.openAlertGetMessage('W0001', ['出力対象']);
         return;
      }
      // 「会員生協」が"全生協"以外の場合は選択ページ件数チェックを行う。
      if (this.cmb_Coop.selectedCoopCode !== '*' && PlessViewUtilsSub.isEmpty(this.kymw2300Model.getSelectedPageIdList())) {
        this.dialogService.openAlertGetMessage('E0107', ['会員生協に「全生協」以外', 'ページ']);
        return;
      }
      // // 出力対象のチェックを行う。
      if (this.cmb_TargetProgress.selectedCodeValue !== '*') {
        this.dialogService.openAlertGetMessage('E0274', );
        return;
      }
      // 出力指定のチェック設定
      this.ckb_Manuscripts.selected = true;
      this.ckb_EditDifferenceList.selected = false;
      this.ckb_BuyerDifferenceList.selected = false;
      // 比較フェーズの設定
      this.cmb_CompareProgress.setCodeValue('');
      // 比較フェーズの変更イベント
      this.eventCmbCompareProgress_CHANGEHandler();

      // API呼び出し
      const vo = this.kymw2300Model.getExecutePrintCompanyDataThumbnaiVO();
      this.executePrintCompanyDataThumbnailService.execute(this.kymw2300Model, vo, (data: any) => {
        this.data = data;
      });
    }
  }

  /**
   * 全てチェックボタン押下イベント
   */
  public eventBtnAllCheck_CLICKHandler(): void {
    this.kymw2300Model.updatePageListAllSelected(true);
  }

  /**
   * チェック解除ボタン押下イベント
   */
  public eventBtnAllUnCheckt_CLICKHandler(): void {
    this.kymw2300Model.updatePageListAllSelected(false);
  }

  /**
   * 出力方法初期処理
   */
  public updateRadAllDiff(): void {
    if (PlessViewUtilsSub.isEmpty(this.cmb_CompareProgress.selectedCodeValue)) {
      this.kymw2300Model.outputType = '0';                                      // 出力方法タイプ(0：全て)
      this.plessEnabled(this.rdb_Diff, false);
    } else {
      this.plessEnabled(this.rdb_Diff, true);
    }
  }

  /**
   * 出力対象変更イベント
   */
  public eventCmbTargetProgress_CHANGEHandler(): void {
    // 最新情報】を選択:チェックなし
    if (PlessViewUtilsSub.isEmpty(this.cmb_TargetProgress.selectedCodeValue)) {
      this.cmb_CompareProgress.setCodeValue('');
      this.kymw2300Model.pageList = new Array<any>();
      this.kymw2300Model.selectedTargetProgressNum = this.cmb_TargetProgress.selectedCodeValue;
    } else {
      if (!PlessViewUtilsSub.isEmpty(this.cmb_CompareProgress.selectedCodeValue)) {
        if (this.cmb_TargetProgress.selectedCodeValue === '*'
          && this.cmb_CompareProgress.selectedCodeValue > this.cmb_TargetProgress.selectedCodeValue) {
          this.dialogService.openAlertGetMessage('E0183', ['「出力対象」', '「比較フェーズ」', 'より後ろのフェーズ', '選択'],
          (closeDetail) => {
            this.kymw2300Model.rollBackCmbTargetProgress(closeDetail);
          });
          return;
        }
      }
      // 【受注コード、媒体、会員生協、出力対象】全部入力された場合
      if (this.isSelectedAllInfo()) {
        // API呼び出し
        const vo = this.kymw2300Model.getCheckProgressHistoryVO('1');
        this.checkProgressHistoryService.execute(this.kymw2300Model, vo, null);
      } else {
        // ページ一覧をクリアする
        this.kymw2300Model.pageList = new Array<any>();
      }
    }

    this.updateRadAllDiff();
  }

  /**
   * 比較フェーズ変更イベント
   */
  public eventCmbCompareProgress_CHANGEHandler(): void {
    if (PlessViewUtilsSub.isEmpty(this.kymw2300Model.orderCode)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード']);
      return;
    }
    if (!this.txi_OrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('W0024', ['受注コード']);
      return;
    }

    // 【最新情報】を選択:チェックなし
    if (!PlessViewUtilsSub.isEmpty(this.cmb_CompareProgress.selectedCodeValue)) {
      if (PlessViewUtilsSub.isEmpty(this.cmb_TargetProgress.selectedCodeValue)) {
        this.kymw2300Model.selectedCompareProgressNum = '';
        this.updateRadAllDiff();
        this.dialogService.openAlertGetMessage('E0207', ['選択したフェーズ', '「出力対象」が未選択', '選択'],
        (closeDetail) => {
          this.kymw2300Model.rollBackCmbCompareProgress(closeDetail);
        });
        return;
      }

      // 出力対象が＊、未来の場合 */
      if (this.cmb_TargetProgress.selectedCodeValue === '*'
        || this.cmb_CompareProgress.selectedCodeValue < this.cmb_TargetProgress.selectedCodeValue) {
        // API呼び出し
        const vo = this.kymw2300Model.getCheckProgressHistoryVO('2');
        this.checkProgressHistoryService.execute(this.kymw2300Model, vo, null);
      } else {
        this.dialogService.openAlertGetMessage('E0183', ['「比較フェーズ」', '「出力対象」', 'より前のフェーズ', '選択'],
        (closeDetail) => {
          this.kymw2300Model.rollBackCmbCompareProgress(closeDetail);
        });
      }
    } else {
      this.kymw2300Model.selectedCompareProgressNum = this.cmb_CompareProgress.selectedCodeValue;
    }

    this.updateRadAllDiff();
  }
}
